<template>
  <ModalBase 
    show-modal @close-modal="close" 
    :short="modalState !== 'details'" 
    :auto-h="modalState === 'search'" 
    narrow
    :overlay-scrollb="modalState !== 'details'"
  >
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ $gettext('Company profile') }}
        </template>
        <template v-slot:title>
          {{modalTitleText}}
        </template>
        <template v-slot:buttons>
          <GekkoButton 
            v-if="modalState === 'details' && isCompanyDutch"
            @click="importFromKvk()"
            :text="$gettext('Import from KVK')" 
            icon="fa-solid fa-arrow-left" 
            variant="link"
            class="text-info"
          />
          <GekkoButton 
            v-if="modalState !== 'details' && isCompanyDutch"
            @click="changeCompanyDetails()"
            :text="$gettext('Company details')" 
            icon="fa-solid fa-arrow-right" 
            :icon-right="true" 
            variant="link"
            class="text-info"
          />
        </template>
      </TitleBar>
    </template>

    <template v-slot:maincontent>
      <div class="kvk-content-wrap" :class="[modalState]">
        <div v-if="modalState !== 'details'">
          <div class="info-text" v-translate>
            To create a legally correct invoice, it needs to contain your company information. You can easily import this information from the KVK. You can also do this at a later time.
          </div>
          <b-form @submit.prevent="searchCompany()" class="search-div">
            <b-form-input v-model="companyNameText" style="margin-right: 2px" />
            <GekkoButton 
              @click="searchCompany()" 
              :text="$gettext('Search')" 
              class="ml-2"
            />
          </b-form>
        </div>

            <KvkSuggestionsTable 
              v-show="modalState === 'list'"
              ref="kvk_suggestion_table"
              :companyName="companyNameText"
              @companySelected="onCompanySelected" />

            <div v-if="modalState === 'details'" class="h-100">
              <EditCompanyProfile ref="edit_company_profile" :target-data="targetData" @detailsSaved="close()" :selectedCompany="selectedCompany" />
            </div>
          </div>
        </template>

    <template v-slot:actions>
      <GekkoButton 
        @click="close()" 
        :text="$gettext('Cancel')" 
        variant="link"
        class="text-primary px-0"
      />
      <GekkoButton 
        v-if="modalState === 'details'" 
        @click="importCompany()" 
        :text="$gettext('Save')"
        icon="fa-solid fa-floppy-disk"
        class="float-right position-relative"
        :loading="isWaitingForResponse"
      />
    </template>
  </ModalBase>
</template>

<script>
import GekkoButton from '@/components/GekkoButton';
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import EditCompanyProfile from "@/components/dashboard/ui/EditCompanyProfile";
import KvkSuggestionsTable from "@/components/contacts/KvkSuggestionsTable";
import { mapGetters } from "vuex";

export default {
    name: "ImportKvkModal",
    components: {GekkoButton, ModalBase, TitleBar, EditCompanyProfile, KvkSuggestionsTable},
    props: {
      targetData: {
        type: Array,
        default: () => []
      }
    },
    data() {
        return {
            tableFields: [
              { key: "naam", label: this.$gettext('Name') },
              { key: "kvkNummer", label: this.$gettext('KVK'), thClass: 'kvk-col' }
            ],
            modalState: "search", // states: search, list, details
            companyNameText: "",
            companyList: [],
            selectedCompany: null,
            nextPageLink: null,
            prevPageLink: null,
            loadingCompanies: false
        }
    },
    created () {
      this.companyNameText = this.currentCompany.name
      if (!this.currentCompany.kvk && this.isCompanyDutch) {
        this.modalState = "search"
      } else {
        this.modalState = "details"
      }
    },
    methods: {
      close() {
        this.$emit('data-updated', false);
        this.$emit('close-modal', false);
        document.body.classList.remove('modal-on')
        this.showImportKvkModal = false;
      },
      searchCompany() {
        this.modalState = "list";
        this.$refs.kvk_suggestion_table.getCompanyList();
      },
      onCompanySelected(company) {
        this.selectedCompany = company;
        this.modalState = "details";
      },
      importFromKvk() {
        this.searchCompany();
        this.selectedCompany = null;
      },
      changeCompanyDetails() {
        this.modalState = "details";
      },
      importCompany() {
        this.$refs.edit_company_profile.saveCompanyData();
      },
      getFormattedAddress() {
        return `${this.selectedCompany.straatnaam}, ${this.selectedCompany.plaats}`;
      }
    },
    computed: {
      ...mapGetters({ 
        currentCompany: "main/getCurrentCompany",
        isWaitingForResponse: "main/isWaitingForResponse"
      }),
      isCompanyDutch() {
        return this.currentCompany.country === "NL";
      },
      modalTitleText() {
        if (this.modalState === "details")
          return this.$gettext("Company details");
        else
          return this.$gettext("Import from KvK");
      }
    }
}
</script>

<style lang="scss" scoped>
.kvk-content-wrap {
  height: 100%;
  &.list {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

.info-text {
  font-style: italic;
  color: $colorTextSemi;
  font-size: 14px;
  margin-bottom: 1rem;
}

.search-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1rem;
}
</style>